import { Component } from '@angular/core';
import {Location} from "@angular/common";

@Component({
  selector: 'app-page-505',
  templateUrl: './page-505.component.html',
  styleUrls: ['./page-505.component.css'],
  host: {
    class: 'app-page'
  }
})
export class Page505Component {
  constructor(private readonly location: Location) {
  }

  back(): void {
    this.location.back();
  }
}
